import Vue from 'vue'
import App from './App.vue'
import router from '@/router.js'
import store from '@/store.js'
import './assets/css/tailwind.css'
import 'remixicon/fonts/remixicon.css'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import VueExcelXlsx from "vue-excel-xlsx";
import axios from 'axios'
const token = localStorage.getItem('token')
if(token){
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

Vue.use(VueExcelXlsx);
Vue.component('calendar', Calendar)
Vue.component('date-picker', DatePicker)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
  components: {
    Calendar,
    DatePicker
  }
  
}).$mount("#app")
